import NavLink from 'components/Navlink';
import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { getProfile } from 'services/apiRoutes';

export default function Footer() {
  const {slug} = useParams()
  const [profile, setProfile] = useState();

    const year = new Date().getFullYear();

     const profileAPI = useCallback(async () => {
       const res = await getProfile(slug);
       if (res.error) {
         return res.message;
       } else {
         const { data } = res.data;
         setProfile(data);
       }
     }, [slug]);

     useEffect(() => {
       profileAPI(slug);
     }, [profileAPI, slug]);


  return (
    <footer className="py-10 text-white bg-primary">
      <div className="justify-between px-5 xl:flex xl:px-99">
        <div className="mb-10 xl:mb-0 main">
          <h1 className="font-bold ">Geulanggang-Panah</h1>
          <div className="description w-[300px] mt-8">
            <p className="text-sm font-medium text-justify ">
              {profile ? profile.ProfilDesa?.deskripsi : ""}
            </p>
          </div>
        </div>
        <div className="xl:space-x-10 xl:flex navMed ">
          <div className="mb-10 navigasi xl:mb-0">
            <h1 className="mb-8 font-bold">Navigasi</h1>
            <div className="space-y-3">
              <NavLink route={`/${slug}/layanan`} title="Layanan Masyarakat" />
              <NavLink route={`/${slug}/documents`} title="Dokumen" />
              <NavLink route={`/${slug}/berita`} title="Berita" />
              <NavLink route={`/${slug}/kegiatan`} title="Kegiatan" />
            </div>
          </div>
          <div className="medsos">
            <h1 className="mb-8 font-bold">Media Sosial</h1>
            <div className="space-y-3">
              <NavLink route="#" title="Facebook" />
              <NavLink route="#" title="Instagram" />
              <NavLink route="#" title="Twitter" />
            </div>
          </div>
        </div>
      </div>
      <div className="lineV bg-white w-full h-[1px] mt-7" />
      <div className="px-5 xl:px-99 mt-7 ">
        <p className="text-xs text-center xl:text-justify font-extralight">
          © {year} {profile ? profile.ProfilDesa?.nama : ""} - All Rights
          Reserved
        </p>
      </div>
    </footer>
  );
}
